import type { ComponentProps, FC } from "react";

import { EditorButtonRedo, EditorButtonUndo } from "../editor-buttons";
import { EditorButtonGroup } from "./editor-button-group";

export const EditorButtonGroupHistory: FC<ComponentProps<typeof EditorButtonGroup>> = (props) => (
  <EditorButtonGroup {...props}>
    <EditorButtonUndo />
    <EditorButtonRedo />
  </EditorButtonGroup>
);
